import Vue from "vue";
import axios from "axios";
import { loanableAllowsDeclaredExpenses } from "@/billingSettings";

export const features = Vue.observable({
  flags: {},
});

export function featureEnabled(name) {
  return features.flags[name] === true;
}

let pending = Promise.resolve();

export function whenFeaturesLoaded() {
  return pending;
}

export function userDeclaredExpenseEntryDisabled(expense) {
  if (!expense) {
    return false;
  }
  const isUserDeclared = !expense.id || (!expense.loan_id && !expense.locked);
  if (!isUserDeclared) {
    return false;
  }
  if (!expense.loanable) {
    return false;
  }
  return !loanableAllowsDeclaredExpenses(expense.loanable);
}

export function loadFeatures() {
  pending = axios
    .get("/features")
    .then(({ data }) => {
      features.flags = data && !Array.isArray(data) ? data : {};
    })
    .catch(() => {
      features.flags = {};
    });
  return pending;
}
